import { connect } from 'react-redux';
import Item from '../../../../../components/dashboards/cards/builder/event/Item';
import {
  getEventNames,
  getMetainf,
  getDashboardEventName,
  getDashboardEvenIds,
  getDashboardUniqueChar,
} from '../../../../../reducers/analyticsApp';
import { removeComposeEvent, setName } from '../../../../../actions/dashboards/events';

const mapStateToProps = (state, { unitId, eventId }) => ({
  event: getDashboardEventName(state, unitId, eventId),
  events: getEventNames(state),
  multipleEvents: getDashboardEvenIds(state, unitId).length > 1,
  uniqueChar: getDashboardUniqueChar(state, unitId, eventId),
  getEventMetainf: (event) => getMetainf(state, event),
  visible: !!getDashboardEventName(state, unitId, eventId),
});

const mapDispatchToProps = (dispatch, { unitId, eventId }) => ({
  onRemove: () => dispatch(removeComposeEvent(unitId, eventId)),
  onChangeEvent: (...rest) => dispatch(setName(unitId, eventId, ...rest)),
});

const EventsItem = connect(mapStateToProps, mapDispatchToProps)(Item);

export default connect(mapStateToProps, mapDispatchToProps)(EventsItem);
